// Auto-generated asset map for mulnyang game board.
// Do not edit manually.

import img001 from '../../assets/images/mulnyang-bulnyang/overlays/cats/cat_001_base.png';
import img002 from '../../assets/images/mulnyang-bulnyang/overlays/cats/cat_001_easy_normal_odd.png';
import img003 from '../../assets/images/mulnyang-bulnyang/overlays/cats/cat_001_hard_hell_odd.png';
import img004 from '../../assets/images/mulnyang-bulnyang/overlays/cats/cat_002_base.png';
import img005 from '../../assets/images/mulnyang-bulnyang/overlays/cats/cat_002_easy_normal_odd.png';
import img006 from '../../assets/images/mulnyang-bulnyang/overlays/cats/cat_002_hard_hell_odd.png';
import img007 from '../../assets/images/mulnyang-bulnyang/overlays/cats/cat_003_base.png';
import img008 from '../../assets/images/mulnyang-bulnyang/overlays/cats/cat_003_easy_normal_odd.png';
import img009 from '../../assets/images/mulnyang-bulnyang/overlays/cats/cat_003_hard_hell_odd.png';
import img010 from '../../assets/images/mulnyang-bulnyang/overlays/cats/cat_004_base.png';
import img011 from '../../assets/images/mulnyang-bulnyang/overlays/cats/cat_004_easy_normal_odd.png';
import img012 from '../../assets/images/mulnyang-bulnyang/overlays/cats/cat_004_hard_hell_odd.png';
import img013 from '../../assets/images/mulnyang-bulnyang/overlays/cats/cat_005_base.png';
import img014 from '../../assets/images/mulnyang-bulnyang/overlays/cats/cat_005_easy_normal_odd.png';
import img015 from '../../assets/images/mulnyang-bulnyang/overlays/cats/cat_005_hard_hell_odd.png';
import img016 from '../../assets/images/mulnyang-bulnyang/overlays/cats/cat_006_base.png';
import img017 from '../../assets/images/mulnyang-bulnyang/overlays/cats/cat_006_easy_normal_odd.png';
import img018 from '../../assets/images/mulnyang-bulnyang/overlays/cats/cat_006_hard_hell_odd.png';
import img019 from '../../assets/images/mulnyang-bulnyang/overlays/cats/cat_007_base.png';
import img020 from '../../assets/images/mulnyang-bulnyang/overlays/cats/cat_007_easy_normal_odd.png';
import img021 from '../../assets/images/mulnyang-bulnyang/overlays/cats/cat_007_hard_hell_odd.png';
import img022 from '../../assets/images/mulnyang-bulnyang/overlays/cats/cat_008_base.png';
import img023 from '../../assets/images/mulnyang-bulnyang/overlays/cats/cat_008_easy_normal_odd.png';
import img024 from '../../assets/images/mulnyang-bulnyang/overlays/cats/cat_008_hard_hell_odd.png';
import img025 from '../../assets/images/mulnyang-bulnyang/overlays/cats/cat_009_base.png';
import img026 from '../../assets/images/mulnyang-bulnyang/overlays/cats/cat_009_easy_normal_odd.png';
import img027 from '../../assets/images/mulnyang-bulnyang/overlays/cats/cat_009_hard_hell_odd.png';
import img028 from '../../assets/images/mulnyang-bulnyang/overlays/cats/cat_010_base.png';
import img029 from '../../assets/images/mulnyang-bulnyang/overlays/cats/cat_010_easy_normal_odd.png';
import img030 from '../../assets/images/mulnyang-bulnyang/overlays/cats/cat_010_hard_hell_odd.png';
import img031 from '../../assets/images/mulnyang-bulnyang/overlays/cats/cat_011_base.png';
import img032 from '../../assets/images/mulnyang-bulnyang/overlays/cats/cat_011_easy_normal_odd.png';
import img033 from '../../assets/images/mulnyang-bulnyang/overlays/cats/cat_011_hard_hell_odd.png';
import img034 from '../../assets/images/mulnyang-bulnyang/overlays/cats/cat_012_base.png';
import img035 from '../../assets/images/mulnyang-bulnyang/overlays/cats/cat_012_easy_normal_odd.png';
import img036 from '../../assets/images/mulnyang-bulnyang/overlays/cats/cat_012_hard_hell_odd.png';
import img037 from '../../assets/images/mulnyang-bulnyang/overlays/cats/cat_013_base.png';
import img038 from '../../assets/images/mulnyang-bulnyang/overlays/cats/cat_013_easy_normal_odd.png';
import img039 from '../../assets/images/mulnyang-bulnyang/overlays/cats/cat_013_hard_hell_odd.png';
import img040 from '../../assets/images/mulnyang-bulnyang/overlays/cats/cat_014_base.png';
import img041 from '../../assets/images/mulnyang-bulnyang/overlays/cats/cat_014_easy_normal_odd.png';
import img042 from '../../assets/images/mulnyang-bulnyang/overlays/cats/cat_014_hard_hell_odd.png';
import img043 from '../../assets/images/mulnyang-bulnyang/overlays/cats/cat_015_base.png';
import img044 from '../../assets/images/mulnyang-bulnyang/overlays/cats/cat_015_easy_normal_odd.png';
import img045 from '../../assets/images/mulnyang-bulnyang/overlays/cats/cat_015_hard_hell_odd.png';
import img046 from '../../assets/images/mulnyang-bulnyang/overlays/cats/cat_016_base.png';
import img047 from '../../assets/images/mulnyang-bulnyang/overlays/cats/cat_016_easy_normal_odd.png';
import img048 from '../../assets/images/mulnyang-bulnyang/overlays/cats/cat_016_hard_hell_odd.png';
import img049 from '../../assets/images/mulnyang-bulnyang/overlays/cats/cat_017_base.png';
import img050 from '../../assets/images/mulnyang-bulnyang/overlays/cats/cat_017_easy_normal_odd.png';
import img051 from '../../assets/images/mulnyang-bulnyang/overlays/cats/cat_017_hard_hell_odd.png';
import img052 from '../../assets/images/mulnyang-bulnyang/overlays/cats/cat_018_base.png';
import img053 from '../../assets/images/mulnyang-bulnyang/overlays/cats/cat_018_easy_normal_odd.png';
import img054 from '../../assets/images/mulnyang-bulnyang/overlays/cats/cat_018_hard_hell_odd.png';
import img055 from '../../assets/images/mulnyang-bulnyang/overlays/cats/cat_019_base.png';
import img056 from '../../assets/images/mulnyang-bulnyang/overlays/cats/cat_019_easy_normal_odd.png';
import img057 from '../../assets/images/mulnyang-bulnyang/overlays/cats/cat_019_hard_hell_odd.png';
import img058 from '../../assets/images/mulnyang-bulnyang/overlays/cats/cat_020_base.png';
import img059 from '../../assets/images/mulnyang-bulnyang/overlays/cats/cat_020_easy_normal_odd.png';
import img060 from '../../assets/images/mulnyang-bulnyang/overlays/cats/cat_020_hard_hell_odd.png';
import img061 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_ac00.png';
import img062 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_ac04.png';
import img063 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_ac08_2d_31.png';
import img064 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_ac08.png';
import img065 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_ac10_2d_31.png';
import img066 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_ac10_2d_32.png';
import img067 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_ac10.png';
import img068 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_ac11.png';
import img069 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_ac15.png';
import img070 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_ac1c.png';
import img071 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_ac70.png';
import img072 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_ac78.png';
import img073 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_ac8c.png';
import img074 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_ace0.png';
import img075 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_ace1.png';
import img076 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_ace4_2d_31.png';
import img077 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_ace4.png';
import img078 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_ace8_2d_31.png';
import img079 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_ace8.png';
import img080 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_acf0.png';
import img081 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_acf1.png';
import img082 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_ad6c.png';
import img083 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_ad6d.png';
import img084 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_ad70.png';
import img085 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_ad74_2d_31.png';
import img086 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_ad74.png';
import img087 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_adfc.png';
import img088 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_ae4c.png';
import img089 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_b098.png';
import img090 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_b0a8.png';
import img091 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_b0a9.png';
import img092 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_b0ad.png';
import img093 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_b0e5.png';
import img094 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_b108.png';
import img095 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_b178.png';
import img096 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_b204.png';
import img097 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_b2e4.png';
import img098 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_b2ec_2d_31.png';
import img099 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_b2ec.png';
import img100 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_b2f4.png';
import img101 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_b2f5.png';
import img102 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_b300.png';
import img103 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_b354.png';
import img104 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_b35c.png';
import img105 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_b364.png';
import img106 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_b370.png';
import img107 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_b3c4.png';
import img108 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_b3c5.png';
import img109 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_b3c8_2d_31.png';
import img110 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_b3c8.png';
import img111 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_b3cc.png';
import img112 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_b450.png';
import img113 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_b4e0.png';
import img114 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_b4e4.png';
import img115 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_b538.png';
import img116 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_b5a1.png';
import img117 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_b860.png';
import img118 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_b978.png';
import img119 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_b9cc.png';
import img120 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_b9d0.png';
import img121 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_b9d8.png';
import img122 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_ba40.png';
import img123 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_baa8.png';
import img124 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_baa9.png';
import img125 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_baac.png';
import img126 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_bab0.png';
import img127 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_bb34.png';
import img128 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_bb3c.png';
import img129 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_bc14.png';
import img130 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_bc18_2d_31.png';
import img131 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_bc18.png';
import img132 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_bc1c_2d_31.png';
import img133 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_bc1c.png';
import img134 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_bc24_2d_31.png';
import img135 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_bc24.png';
import img136 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_bc25.png';
import img137 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_bc30.png';
import img138 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_bc84.png';
import img139 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_bc8c.png';
import img140 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_bca0.png';
import img141 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_bcc4.png';
import img142 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_bcfc.png';
import img143 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_bd09.png';
import img144 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_bd88_2d_31.png';
import img145 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_bd88.png';
import img146 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_be68.png';
import img147 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_c0ac_2d_31.png';
import img148 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_c0ac.png';
import img149 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_c0b0.png';
import img150 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_c0b4_2d_31.png';
import img151 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_c0b4.png';
import img152 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_c0bc_2d_31.png';
import img153 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_c0bc.png';
import img154 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_c0bd.png';
import img155 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_c0c1.png';
import img156 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_c0c8.png';
import img157 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_c11c.png';
import img158 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_c120.png';
import img159 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_c124.png';
import img160 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_c138.png';
import img161 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_c18c.png';
import img162 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_c190.png';
import img163 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_c218.png';
import img164 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_c219.png';
import img165 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_c21c.png';
import img166 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_c2a8.png';
import img167 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_c2e0.png';
import img168 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_c2ec.png';
import img169 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_c2f8.png';
import img170 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_c300.png';
import img171 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_c30d.png';
import img172 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_c36c.png';
import img173 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_c544.png';
import img174 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_c57c.png';
import img175 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_c639.png';
import img176 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_c6c5.png';
import img177 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_c77d.png';
import img178 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_c783.png';
import img179 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_c790.png';
import img180 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_c794.png';
import img181 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_c7a0.png';
import img182 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_c7a1.png';
import img183 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_c810.png';
import img184 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_c811.png';
import img185 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_c815.png';
import img186 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_c878.png';
import img187 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_c904.png';
import img188 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_c9d0.png';
import img189 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_c9d1_2d_31.png';
import img190 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_c9d1.png';
import img191 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_c9dc.png';
import img192 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_cc28_2d_31.png';
import img193 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_cc28.png';
import img194 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_cc2c.png';
import img195 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_ccad.png';
import img196 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_ce69.png';
import img197 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_ce74.png';
import img198 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_ce7c.png';
import img199 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_ce84.png';
import img200 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_ce89.png';
import img201 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_cf5c.png';
import img202 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_cfe8.png';
import img203 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_d0c8_2d_31.png';
import img204 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_d0c8.png';
import img205 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_d131.png';
import img206 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_d140.png';
import img207 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_d1a8.png';
import img208 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_d2c0.png';
import img209 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_d310.png';
import img210 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_d314_2d_31.png';
import img211 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_d314.png';
import img212 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_d3bc.png';
import img213 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_d3f4.png';
import img214 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_d401.png';
import img215 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_d480_2d_31.png';
import img216 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_d480.png';
import img217 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_d574.png';
import img218 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_d5e4.png';
import img219 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_d68c.png';
import img220 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_d6fc.png';
import img221 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_gaebul.png';
import img222 from '../../assets/images/mulnyang-bulnyang/overlays/letters/ko_gebol.png';
import img223 from '../../assets/images/mulnyang-bulnyang/overlays/numbers/0.png';
import img224 from '../../assets/images/mulnyang-bulnyang/overlays/numbers/1.png';
import img225 from '../../assets/images/mulnyang-bulnyang/overlays/numbers/100.png';
import img226 from '../../assets/images/mulnyang-bulnyang/overlays/numbers/12.png';
import img227 from '../../assets/images/mulnyang-bulnyang/overlays/numbers/13.png';
import img228 from '../../assets/images/mulnyang-bulnyang/overlays/numbers/17.png';
import img229 from '../../assets/images/mulnyang-bulnyang/overlays/numbers/18.png';
import img230 from '../../assets/images/mulnyang-bulnyang/overlays/numbers/186.png';
import img231 from '../../assets/images/mulnyang-bulnyang/overlays/numbers/188.png';
import img232 from '../../assets/images/mulnyang-bulnyang/overlays/numbers/3.png';
import img233 from '../../assets/images/mulnyang-bulnyang/overlays/numbers/313.png';
import img234 from '../../assets/images/mulnyang-bulnyang/overlays/numbers/318.png';
import img235 from '../../assets/images/mulnyang-bulnyang/overlays/numbers/369.png';
import img236 from '../../assets/images/mulnyang-bulnyang/overlays/numbers/39.png';
import img237 from '../../assets/images/mulnyang-bulnyang/overlays/numbers/396.png';
import img238 from '../../assets/images/mulnyang-bulnyang/overlays/numbers/486.png';
import img239 from '../../assets/images/mulnyang-bulnyang/overlays/numbers/488.png';
import img240 from '../../assets/images/mulnyang-bulnyang/overlays/numbers/6-1.png';
import img241 from '../../assets/images/mulnyang-bulnyang/overlays/numbers/6.png';
import img242 from '../../assets/images/mulnyang-bulnyang/overlays/numbers/60.png';
import img243 from '../../assets/images/mulnyang-bulnyang/overlays/numbers/609.png';
import img244 from '../../assets/images/mulnyang-bulnyang/overlays/numbers/66.png';
import img245 from '../../assets/images/mulnyang-bulnyang/overlays/numbers/669.png';
import img246 from '../../assets/images/mulnyang-bulnyang/overlays/numbers/68.png';
import img247 from '../../assets/images/mulnyang-bulnyang/overlays/numbers/69.png';
import img248 from '../../assets/images/mulnyang-bulnyang/overlays/numbers/699.png';
import img249 from '../../assets/images/mulnyang-bulnyang/overlays/numbers/7.png';
import img250 from '../../assets/images/mulnyang-bulnyang/overlays/numbers/700.png';
import img251 from '../../assets/images/mulnyang-bulnyang/overlays/numbers/8-1.png';
import img252 from '../../assets/images/mulnyang-bulnyang/overlays/numbers/8-2.png';
import img253 from '../../assets/images/mulnyang-bulnyang/overlays/numbers/8.png';
import img254 from '../../assets/images/mulnyang-bulnyang/overlays/numbers/806.png';
import img255 from '../../assets/images/mulnyang-bulnyang/overlays/numbers/808.png';
import img256 from '../../assets/images/mulnyang-bulnyang/overlays/numbers/86.png';
import img257 from '../../assets/images/mulnyang-bulnyang/overlays/numbers/88.png';
import img258 from '../../assets/images/mulnyang-bulnyang/overlays/numbers/89.png';
import img259 from '../../assets/images/mulnyang-bulnyang/overlays/numbers/9.png';
import img260 from '../../assets/images/mulnyang-bulnyang/overlays/numbers/90.png';
import img261 from '../../assets/images/mulnyang-bulnyang/overlays/numbers/96.png';
import img262 from '../../assets/images/mulnyang-bulnyang/overlays/numbers/999.png';
import img263 from '../../assets/images/mulnyang-bulnyang/tiles/tile_01_base.png';
import img264 from '../../assets/images/mulnyang-bulnyang/tiles/tile_01_dim.png';
import img265 from '../../assets/images/mulnyang-bulnyang/tiles/tile_02_base.png';
import img266 from '../../assets/images/mulnyang-bulnyang/tiles/tile_02_dim.png';
import img267 from '../../assets/images/mulnyang-bulnyang/tiles/tile_03_base.png';
import img268 from '../../assets/images/mulnyang-bulnyang/tiles/tile_03_dim.png';
import img269 from '../../assets/images/mulnyang-bulnyang/tiles/tile_04_base.png';
import img270 from '../../assets/images/mulnyang-bulnyang/tiles/tile_04_dim.png';
import img271 from '../../assets/images/mulnyang-bulnyang/tiles/tile_05_base.png';
import img272 from '../../assets/images/mulnyang-bulnyang/tiles/tile_05_dim.png';
import img273 from '../../assets/images/mulnyang-bulnyang/tiles/tile_06_base.png';
import img274 from '../../assets/images/mulnyang-bulnyang/tiles/tile_06_dim.png';
import img275 from '../../assets/images/mulnyang-bulnyang/tiles/tile_07_base.png';
import img276 from '../../assets/images/mulnyang-bulnyang/tiles/tile_07_dim.png';

export const MULNYANG_ASSET_MAP = {
  "overlays/cats/cat_001_base.png": img001,
  "overlays/cats/cat_001_easy_normal_odd.png": img002,
  "overlays/cats/cat_001_hard_hell_odd.png": img003,
  "overlays/cats/cat_002_base.png": img004,
  "overlays/cats/cat_002_easy_normal_odd.png": img005,
  "overlays/cats/cat_002_hard_hell_odd.png": img006,
  "overlays/cats/cat_003_base.png": img007,
  "overlays/cats/cat_003_easy_normal_odd.png": img008,
  "overlays/cats/cat_003_hard_hell_odd.png": img009,
  "overlays/cats/cat_004_base.png": img010,
  "overlays/cats/cat_004_easy_normal_odd.png": img011,
  "overlays/cats/cat_004_hard_hell_odd.png": img012,
  "overlays/cats/cat_005_base.png": img013,
  "overlays/cats/cat_005_easy_normal_odd.png": img014,
  "overlays/cats/cat_005_hard_hell_odd.png": img015,
  "overlays/cats/cat_006_base.png": img016,
  "overlays/cats/cat_006_easy_normal_odd.png": img017,
  "overlays/cats/cat_006_hard_hell_odd.png": img018,
  "overlays/cats/cat_007_base.png": img019,
  "overlays/cats/cat_007_easy_normal_odd.png": img020,
  "overlays/cats/cat_007_hard_hell_odd.png": img021,
  "overlays/cats/cat_008_base.png": img022,
  "overlays/cats/cat_008_easy_normal_odd.png": img023,
  "overlays/cats/cat_008_hard_hell_odd.png": img024,
  "overlays/cats/cat_009_base.png": img025,
  "overlays/cats/cat_009_easy_normal_odd.png": img026,
  "overlays/cats/cat_009_hard_hell_odd.png": img027,
  "overlays/cats/cat_010_base.png": img028,
  "overlays/cats/cat_010_easy_normal_odd.png": img029,
  "overlays/cats/cat_010_hard_hell_odd.png": img030,
  "overlays/cats/cat_011_base.png": img031,
  "overlays/cats/cat_011_easy_normal_odd.png": img032,
  "overlays/cats/cat_011_hard_hell_odd.png": img033,
  "overlays/cats/cat_012_base.png": img034,
  "overlays/cats/cat_012_easy_normal_odd.png": img035,
  "overlays/cats/cat_012_hard_hell_odd.png": img036,
  "overlays/cats/cat_013_base.png": img037,
  "overlays/cats/cat_013_easy_normal_odd.png": img038,
  "overlays/cats/cat_013_hard_hell_odd.png": img039,
  "overlays/cats/cat_014_base.png": img040,
  "overlays/cats/cat_014_easy_normal_odd.png": img041,
  "overlays/cats/cat_014_hard_hell_odd.png": img042,
  "overlays/cats/cat_015_base.png": img043,
  "overlays/cats/cat_015_easy_normal_odd.png": img044,
  "overlays/cats/cat_015_hard_hell_odd.png": img045,
  "overlays/cats/cat_016_base.png": img046,
  "overlays/cats/cat_016_easy_normal_odd.png": img047,
  "overlays/cats/cat_016_hard_hell_odd.png": img048,
  "overlays/cats/cat_017_base.png": img049,
  "overlays/cats/cat_017_easy_normal_odd.png": img050,
  "overlays/cats/cat_017_hard_hell_odd.png": img051,
  "overlays/cats/cat_018_base.png": img052,
  "overlays/cats/cat_018_easy_normal_odd.png": img053,
  "overlays/cats/cat_018_hard_hell_odd.png": img054,
  "overlays/cats/cat_019_base.png": img055,
  "overlays/cats/cat_019_easy_normal_odd.png": img056,
  "overlays/cats/cat_019_hard_hell_odd.png": img057,
  "overlays/cats/cat_020_base.png": img058,
  "overlays/cats/cat_020_easy_normal_odd.png": img059,
  "overlays/cats/cat_020_hard_hell_odd.png": img060,
  "overlays/letters/ko_ac00.png": img061,
  "overlays/letters/ko_ac04.png": img062,
  "overlays/letters/ko_ac08_2d_31.png": img063,
  "overlays/letters/ko_ac08.png": img064,
  "overlays/letters/ko_ac10_2d_31.png": img065,
  "overlays/letters/ko_ac10_2d_32.png": img066,
  "overlays/letters/ko_ac10.png": img067,
  "overlays/letters/ko_ac11.png": img068,
  "overlays/letters/ko_ac15.png": img069,
  "overlays/letters/ko_ac1c.png": img070,
  "overlays/letters/ko_ac70.png": img071,
  "overlays/letters/ko_ac78.png": img072,
  "overlays/letters/ko_ac8c.png": img073,
  "overlays/letters/ko_ace0.png": img074,
  "overlays/letters/ko_ace1.png": img075,
  "overlays/letters/ko_ace4_2d_31.png": img076,
  "overlays/letters/ko_ace4.png": img077,
  "overlays/letters/ko_ace8_2d_31.png": img078,
  "overlays/letters/ko_ace8.png": img079,
  "overlays/letters/ko_acf0.png": img080,
  "overlays/letters/ko_acf1.png": img081,
  "overlays/letters/ko_ad6c.png": img082,
  "overlays/letters/ko_ad6d.png": img083,
  "overlays/letters/ko_ad70.png": img084,
  "overlays/letters/ko_ad74_2d_31.png": img085,
  "overlays/letters/ko_ad74.png": img086,
  "overlays/letters/ko_adfc.png": img087,
  "overlays/letters/ko_ae4c.png": img088,
  "overlays/letters/ko_b098.png": img089,
  "overlays/letters/ko_b0a8.png": img090,
  "overlays/letters/ko_b0a9.png": img091,
  "overlays/letters/ko_b0ad.png": img092,
  "overlays/letters/ko_b0e5.png": img093,
  "overlays/letters/ko_b108.png": img094,
  "overlays/letters/ko_b178.png": img095,
  "overlays/letters/ko_b204.png": img096,
  "overlays/letters/ko_b2e4.png": img097,
  "overlays/letters/ko_b2ec_2d_31.png": img098,
  "overlays/letters/ko_b2ec.png": img099,
  "overlays/letters/ko_b2f4.png": img100,
  "overlays/letters/ko_b2f5.png": img101,
  "overlays/letters/ko_b300.png": img102,
  "overlays/letters/ko_b354.png": img103,
  "overlays/letters/ko_b35c.png": img104,
  "overlays/letters/ko_b364.png": img105,
  "overlays/letters/ko_b370.png": img106,
  "overlays/letters/ko_b3c4.png": img107,
  "overlays/letters/ko_b3c5.png": img108,
  "overlays/letters/ko_b3c8_2d_31.png": img109,
  "overlays/letters/ko_b3c8.png": img110,
  "overlays/letters/ko_b3cc.png": img111,
  "overlays/letters/ko_b450.png": img112,
  "overlays/letters/ko_b4e0.png": img113,
  "overlays/letters/ko_b4e4.png": img114,
  "overlays/letters/ko_b538.png": img115,
  "overlays/letters/ko_b5a1.png": img116,
  "overlays/letters/ko_b860.png": img117,
  "overlays/letters/ko_b978.png": img118,
  "overlays/letters/ko_b9cc.png": img119,
  "overlays/letters/ko_b9d0.png": img120,
  "overlays/letters/ko_b9d8.png": img121,
  "overlays/letters/ko_ba40.png": img122,
  "overlays/letters/ko_baa8.png": img123,
  "overlays/letters/ko_baa9.png": img124,
  "overlays/letters/ko_baac.png": img125,
  "overlays/letters/ko_bab0.png": img126,
  "overlays/letters/ko_bb34.png": img127,
  "overlays/letters/ko_bb3c.png": img128,
  "overlays/letters/ko_bc14.png": img129,
  "overlays/letters/ko_bc18_2d_31.png": img130,
  "overlays/letters/ko_bc18.png": img131,
  "overlays/letters/ko_bc1c_2d_31.png": img132,
  "overlays/letters/ko_bc1c.png": img133,
  "overlays/letters/ko_bc24_2d_31.png": img134,
  "overlays/letters/ko_bc24.png": img135,
  "overlays/letters/ko_bc25.png": img136,
  "overlays/letters/ko_bc30.png": img137,
  "overlays/letters/ko_bc84.png": img138,
  "overlays/letters/ko_bc8c.png": img139,
  "overlays/letters/ko_bca0.png": img140,
  "overlays/letters/ko_bcc4.png": img141,
  "overlays/letters/ko_bcfc.png": img142,
  "overlays/letters/ko_bd09.png": img143,
  "overlays/letters/ko_bd88_2d_31.png": img144,
  "overlays/letters/ko_bd88.png": img145,
  "overlays/letters/ko_be68.png": img146,
  "overlays/letters/ko_c0ac_2d_31.png": img147,
  "overlays/letters/ko_c0ac.png": img148,
  "overlays/letters/ko_c0b0.png": img149,
  "overlays/letters/ko_c0b4_2d_31.png": img150,
  "overlays/letters/ko_c0b4.png": img151,
  "overlays/letters/ko_c0bc_2d_31.png": img152,
  "overlays/letters/ko_c0bc.png": img153,
  "overlays/letters/ko_c0bd.png": img154,
  "overlays/letters/ko_c0c1.png": img155,
  "overlays/letters/ko_c0c8.png": img156,
  "overlays/letters/ko_c11c.png": img157,
  "overlays/letters/ko_c120.png": img158,
  "overlays/letters/ko_c124.png": img159,
  "overlays/letters/ko_c138.png": img160,
  "overlays/letters/ko_c18c.png": img161,
  "overlays/letters/ko_c190.png": img162,
  "overlays/letters/ko_c218.png": img163,
  "overlays/letters/ko_c219.png": img164,
  "overlays/letters/ko_c21c.png": img165,
  "overlays/letters/ko_c2a8.png": img166,
  "overlays/letters/ko_c2e0.png": img167,
  "overlays/letters/ko_c2ec.png": img168,
  "overlays/letters/ko_c2f8.png": img169,
  "overlays/letters/ko_c300.png": img170,
  "overlays/letters/ko_c30d.png": img171,
  "overlays/letters/ko_c36c.png": img172,
  "overlays/letters/ko_c544.png": img173,
  "overlays/letters/ko_c57c.png": img174,
  "overlays/letters/ko_c639.png": img175,
  "overlays/letters/ko_c6c5.png": img176,
  "overlays/letters/ko_c77d.png": img177,
  "overlays/letters/ko_c783.png": img178,
  "overlays/letters/ko_c790.png": img179,
  "overlays/letters/ko_c794.png": img180,
  "overlays/letters/ko_c7a0.png": img181,
  "overlays/letters/ko_c7a1.png": img182,
  "overlays/letters/ko_c810.png": img183,
  "overlays/letters/ko_c811.png": img184,
  "overlays/letters/ko_c815.png": img185,
  "overlays/letters/ko_c878.png": img186,
  "overlays/letters/ko_c904.png": img187,
  "overlays/letters/ko_c9d0.png": img188,
  "overlays/letters/ko_c9d1_2d_31.png": img189,
  "overlays/letters/ko_c9d1.png": img190,
  "overlays/letters/ko_c9dc.png": img191,
  "overlays/letters/ko_cc28_2d_31.png": img192,
  "overlays/letters/ko_cc28.png": img193,
  "overlays/letters/ko_cc2c.png": img194,
  "overlays/letters/ko_ccad.png": img195,
  "overlays/letters/ko_ce69.png": img196,
  "overlays/letters/ko_ce74.png": img197,
  "overlays/letters/ko_ce7c.png": img198,
  "overlays/letters/ko_ce84.png": img199,
  "overlays/letters/ko_ce89.png": img200,
  "overlays/letters/ko_cf5c.png": img201,
  "overlays/letters/ko_cfe8.png": img202,
  "overlays/letters/ko_d0c8_2d_31.png": img203,
  "overlays/letters/ko_d0c8.png": img204,
  "overlays/letters/ko_d131.png": img205,
  "overlays/letters/ko_d140.png": img206,
  "overlays/letters/ko_d1a8.png": img207,
  "overlays/letters/ko_d2c0.png": img208,
  "overlays/letters/ko_d310.png": img209,
  "overlays/letters/ko_d314_2d_31.png": img210,
  "overlays/letters/ko_d314.png": img211,
  "overlays/letters/ko_d3bc.png": img212,
  "overlays/letters/ko_d3f4.png": img213,
  "overlays/letters/ko_d401.png": img214,
  "overlays/letters/ko_d480_2d_31.png": img215,
  "overlays/letters/ko_d480.png": img216,
  "overlays/letters/ko_d574.png": img217,
  "overlays/letters/ko_d5e4.png": img218,
  "overlays/letters/ko_d68c.png": img219,
  "overlays/letters/ko_d6fc.png": img220,
  "overlays/letters/ko_gaebul.png": img221,
  "overlays/letters/ko_gebol.png": img222,
  "overlays/numbers/0.png": img223,
  "overlays/numbers/1.png": img224,
  "overlays/numbers/100.png": img225,
  "overlays/numbers/12.png": img226,
  "overlays/numbers/13.png": img227,
  "overlays/numbers/17.png": img228,
  "overlays/numbers/18.png": img229,
  "overlays/numbers/186.png": img230,
  "overlays/numbers/188.png": img231,
  "overlays/numbers/3.png": img232,
  "overlays/numbers/313.png": img233,
  "overlays/numbers/318.png": img234,
  "overlays/numbers/369.png": img235,
  "overlays/numbers/39.png": img236,
  "overlays/numbers/396.png": img237,
  "overlays/numbers/486.png": img238,
  "overlays/numbers/488.png": img239,
  "overlays/numbers/6-1.png": img240,
  "overlays/numbers/6.png": img241,
  "overlays/numbers/60.png": img242,
  "overlays/numbers/609.png": img243,
  "overlays/numbers/66.png": img244,
  "overlays/numbers/669.png": img245,
  "overlays/numbers/68.png": img246,
  "overlays/numbers/69.png": img247,
  "overlays/numbers/699.png": img248,
  "overlays/numbers/7.png": img249,
  "overlays/numbers/700.png": img250,
  "overlays/numbers/8-1.png": img251,
  "overlays/numbers/8-2.png": img252,
  "overlays/numbers/8.png": img253,
  "overlays/numbers/806.png": img254,
  "overlays/numbers/808.png": img255,
  "overlays/numbers/86.png": img256,
  "overlays/numbers/88.png": img257,
  "overlays/numbers/89.png": img258,
  "overlays/numbers/9.png": img259,
  "overlays/numbers/90.png": img260,
  "overlays/numbers/96.png": img261,
  "overlays/numbers/999.png": img262,
  "tiles/tile_01_base.png": img263,
  "tiles/tile_01_dim.png": img264,
  "tiles/tile_02_base.png": img265,
  "tiles/tile_02_dim.png": img266,
  "tiles/tile_03_base.png": img267,
  "tiles/tile_03_dim.png": img268,
  "tiles/tile_04_base.png": img269,
  "tiles/tile_04_dim.png": img270,
  "tiles/tile_05_base.png": img271,
  "tiles/tile_05_dim.png": img272,
  "tiles/tile_06_base.png": img273,
  "tiles/tile_06_dim.png": img274,
  "tiles/tile_07_base.png": img275,
  "tiles/tile_07_dim.png": img276,
};
